import { type ReactElement, type ReactNode } from "react"
// import spinner from "../assests/images/loading.svg"

export interface SpinnerProps {
        title: string
}

export default function Spinner(props: SpinnerProps): ReactElement {

        return <>
                <div className="grid">
                        <div className="fixed z-20 inset-0 flex backdrop-blur-sm items-center justify-center bg-black bg-opacity-50">
                                <div className="flex flex-col justify-center max-w-[7rem] p-6 w-full relative">
                                        <label className="text-center text-white">{props.title}</label>
                                        <div>
                                                <svg fill="hsl(228, 97%, 42%)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="12" r="3"><animate id="spinner_qFRN" begin="0;spinner_OcgL.end+0.25s" attributeName="cy" calcMode="spline" dur="0.6s" values="12;6;12" keySplines=".33,.66,.66,1;.33,0,.66,.33" /></circle><circle cx="12" cy="12" r="3"><animate begin="spinner_qFRN.begin+0.1s" attributeName="cy" calcMode="spline" dur="0.6s" values="12;6;12" keySplines=".33,.66,.66,1;.33,0,.66,.33" /></circle><circle cx="20" cy="12" r="3"><animate id="spinner_OcgL" begin="spinner_qFRN.begin+0.2s" attributeName="cy" calcMode="spline" dur="0.6s" values="12;6;12" keySplines=".33,.66,.66,1;.33,0,.66,.33" /></circle></svg>
                                        </div>

                                </div>
                        </div>
                </div>
        </>
}

